<template>
  <b-modal v-model="showModal"
           @ok="sendReport"
           :ok-disabled="state.isAdding">
    <div slot="modal-title">
      {{ $t('message.my_reservations.report_issue_title') }}{{ order.order_code }}
    </div>
    <section>
      <textarea id="issue"
                rows="4"
                ref="issue"
                v-model="issue"
                class="form-control textarea-jumbo"
                :placeholder="$t('message.my_reservations.report_issue_placeholder')"></textarea>
    </section>
    <div slot="modal-cancel" @click="showModal = false">{{ $t('message.button.close') }}</div>
    <div slot="modal-ok">{{ $t(isAdding) }}</div>
  </b-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import i18n from '../../../helpers/i18nHelpers'

  export default {
    data () {
      return {
        showModal: false,
        order: null,
        issue: ''
      }
    },
    computed: {
      ...mapGetters({
        isAdding: 'reportIssue/isAdding',
        state: 'reportIssue/getState'
      })
    },
    watch: {
      isAdding () {
        if (!this.state.isAdding) {
          this.showReportIssueModal(false)
          this.$swal({title: i18n.t('message.success'), text: i18n.t('message.my_reservations.report_issue_thank_you'), type: 'success'})
          this.loadOrderDetail(this.order.id)
        }
      }
    },
    methods: {
      ...mapActions('orderDetail', ['loadOrderDetail']),
      showReportIssueModal (status) {
        this.showModal = status
        this.issue = ''
      },
      setOrderData (order) {
        this.order = order
      },
      sendReport (evt) {
        // Prevent modal from closing
        evt.preventDefault()
        if (this.issue) {
          const submitData = {
            order_id: this.order.id,
            issue: this.issue
          }
          this.$store.dispatch('reportIssue/ADD_REPORT_ISSUE', submitData)
        } else {
          this.$refs.issue.focus()
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/order/components/ReportIssueModal.vue